import { FC } from "react"

import { useTranslation } from "react-i18next"

import { AccordionTable } from "components/tables/AccordionTable/AccordionTable"

import { BalanceTerminalsEditorTable } from "features/balance/BalanceTerminalsEditorTable"

import { SortOrderType } from "constants/eums"
import { TableColumnsInterface } from "constants/interfaces"

import { balanceService } from "services/balance/balance.service"
import { BalanceTxType } from "services/balance/type"

import { isMicroserviceTenant } from "config/featureFlags"

interface BalanceProcessorTableProps {
  txType: BalanceTxType
  processorColumns: TableColumnsInterface[]
  methodColumns: TableColumnsInterface[]
  rangeParams: Record<string, any>
}

// The AccordionTable default (created_at) isn't a balance sort key.
const DEFAULT_SORT_ORDER_BY = "volume_usd_cents"

const getDefaultSort = () => {
  if (isMicroserviceTenant()) {
    return { defaultSortOrderBy: DEFAULT_SORT_ORDER_BY, defaultSortOrder: SortOrderType.DESC }
  }
  return {}
}

export const BalanceProcessorTable: FC<BalanceProcessorTableProps> = ({ txType, processorColumns, methodColumns, rangeParams }) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const defaultSort = getDefaultSort()

  return (
    <AccordionTable
      title={t("balance.terminalFees")}
      handler={balanceService.getTerminalProcessorsTable}
      columns={processorColumns}
      filters={rangeParams}
      {...defaultSort}
      renderExpanded={(pRow) => (
        <div className="p-4">
          <AccordionTable
            id={pRow.processor}
            idTrue
            title={t("balance.paymentMethodsFor", { processor: pRow.processor })}
            handler={balanceService.getTerminalMethodsTable}
            columns={methodColumns}
            filters={rangeParams}
            {...defaultSort}
            renderExpanded={(mRow) => (
              <div className="p-4">
                <div className="mb-3 text-sm font-semibold text-[rgba(6,7,21,1)] dark:text-white">
                  {t("balance.terminalsFor", { processor: pRow.processor, method: mRow.payment_method })}
                </div>

                <BalanceTerminalsEditorTable
                  processor={pRow.processor}
                  payment_method={mRow.payment_method}
                  txType={txType}
                  filters={rangeParams}
                />
              </div>
            )}
          />
        </div>
      )}
    />
  )
}
